var _linearGradient, _linearGradient2, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgNetflixIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "124.528 16 262.944 480",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 108.142,
    x2: 176.518,
    y1: 240.643,
    y2: 189.038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c20000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d0000"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 400.786,
    x2: 338.861,
    xlinkHref: "#a",
    y1: 312.035,
    y2: 337.837
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m216.398 16h-91.87v480c30.128-7.135 61.601-10.708 91.87-12.052z",
    fill: "#c20000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m216.398 16h-91.87v367.267c30.128-7.135 61.601-10.707 91.87-12.051z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m387.472 496v-480h-91.87v468.904c53.636 3.416 91.87 11.096 91.87 11.096z",
    fill: "#c20000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m387.472 496v-318.555h-91.87v307.459c53.636 3.416 91.87 11.096 91.87 11.096z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m387.472 496-171.074-480h-91.87l167.03 468.655c55.75 3.276 95.914 11.345 95.914 11.345z",
    fill: "#fa0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNetflixIcon);
export default __webpack_public_path__ + "static/media/img-netflix-icon.e2fd16667e47af79739fb996b6d3b366.svg";
export { ForwardRef as ReactComponent };